<div class="hub-change-user-container" >
  @if (isUserSelectionPanelVisible) {
    <div class="user-list">
      <div class="hub-select-container">
        <mat-form-field>
          <input type="text" #typeaheadInputControl matInput [formControl]="userTypeaheadInput" [matAutocomplete]="usersAutocomplete" placeholder="Type User Name">
        </mat-form-field>
        <mat-autocomplete #usersAutocomplete="matAutocomplete" [displayWith]="displayUser.bind(this)" (optionSelected)="selectUser($event)">
          @for (user of filteredUsers$ | async; track user) {
            <mat-option [value]="user">
              {{user.fullName}}
            </mat-option>
          }
        </mat-autocomplete>
      </div>
    </div>
  }
  <button class="hub-icon-button" (click)="toggleUserSelector()">
    <b><i class="icon-user"></i></b>Change User
  </button>

</div>
